export const areExternalLinksVisible = window.top === window.self
